<template>
    <Paper class="driver-add-supplier">
        <MPanel
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :pageID="pageID"
            :searchId="searchId"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @btnClick="handleBtnClick"
            @driver-btn="viewDriverInfo"
            @vehicle-btn="viewVehicleInfo">
            <div slot="page-module-btn">
                <!-- <div>
                    <el-button class="bigData-btn-distribute" type="primary" @click="handleApprove">通过</el-button>
                    <el-button class="bigData-btn-distribute" type="primary" @click="handleReject">驳回</el-button>
                </div> -->
                <ButtonGroup :checkedData="checkedData" @fresh="loadData" />
            </div>
            <div slot="table-module-btn">
                <el-button
                    v-has="'/driverAddSupplier-10'"
                    size="mini"
                    class="bigData-btn-all-desensitization"
                    :icon="isSensitive ? 'icon-show' : 'icon-hidden'"
                    @click="handleSensitive"
                ></el-button>
            </div>
        </MPanel>
        <DriverInfo
            :applyStatusText="applyStatusText"
            :applyCode="applyCode"
            :dialogVisible.sync="driverVisible"></DriverInfo>
        <VehicleInfo :applyCode="applyCode" :dialogVisible.sync="vehicleDialogVisible"></VehicleInfo>
    </Paper>
</template>
<script>
import dayjs from 'dayjs'
import MPanel from '@/components/supplierPanel'
import Paper from '@/components/core/paper/Paper'
import { dictWithUrl } from '@/components/lots/api'
import config from './config.js'
import { getRecordList } from '../../../../api/driverAddSupplier.js'
import DriverInfo from './driverInfo.vue'
import VehicleInfo from './VehicleInfo.vue'
import ButtonGroup from './ButtonGroup.vue'
import { getSensitiveVal, handleTableDataSensitive } from '../../../../utils/common.js';

export default {
    name: 'driverAddSupplier',
    components: { Paper, MPanel, DriverInfo, VehicleInfo, ButtonGroup },
    data() {
        return {
            totalData: [],
            pageTotal: 0,
            loading: false,
            pageID: 'transport-demand-20251025',
            searchId: 'transport-demand-sd',
            pageNo: 1,
            searchTerm: {},
            pageSize: 10,
            checkedData: [],
            exportLoading: false,
            dictData: {},
            driverVisible: false,
            vehicleDialogVisible: false,
            applyCode: '', //申请编码
            applyStatusText: '', //申请状态
            isSensitive: true, // 列表数据是否脱敏
        }
    },
    computed: {
        config(){
            if(this.$store.state.supplier && config.searchList.searchTxt[0].value === 'supplierCode'){
                config.searchList.searchTxt.splice(0,2)
                return config
            }else{
                return config
            }
        }
    },
    activated(){
        if (this.$store.state.supplier) {
                //LSP
            if (this.$route.query.applyStatus !== undefined) {
                this.initTimeDefault()
                this.loadData();
            }
        }
    },
    methods: {
        viewDriverInfo(v) {
            if (v.driverDeleteFlag === 1) {
                return this.$message.warning('司机已注销，不可查看司机信息')
            }
            this.applyCode = v.applyCode
            this.applyStatusText = this.dictData['SRM_JOIN_APPLY_STATUS'][v.applyStatus]
            this.driverVisible = true
        },
        viewVehicleInfo(v) {
            this.applyCode = v.applyCode
            this.vehicleDialogVisible = true
        },
        selectChange(data) {
            if (data && data.length > 0) {
                this.checkedData = data
            } else {
                this.checkedData = []
            }
        },
        searchChange(data) {
            this.pageNo = 1
            this.searchTerm = data
            this.loadData()
        },
        pageChange(data) {
            this.isSensitive = true
            this.pageNo = data
            this.loadData()
        },
        sizeChange(data) {
            this.isSensitive = true
            this.pageSize = data
            this.loadData()
        },
        // 处理请求参数
        getParams() {
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                orderBy: 'create_time',
                orderByType: 'desc',
                ...this.searchTerm,
            }
            if(this.$store.state.supplier){
                params.supplierCode = this.$store.state.supplier.supplierCode
            }
            if (params.timeRange) {
                params.startTime = dayjs(params.timeRange[0]).format('YYYY-MM-DD HH:mm:ss')
                params.endTime = dayjs(params.timeRange[1]).format('YYYY-MM-DD HH:mm:ss')
                delete params.timeRange
            }
            for (const key in params) {
                if (Array.isArray(params[key])) {
                    params[key] = params[key].join(',')
                }
            }
            return params
        },
        loadData() {
            const params = this.getParams()
            if (!params.startTime) {
                return this.$message.warning('请选择时间范围')
            }
            if (Math.abs(dayjs(params.startTime).diff(params.endTime, 'day')) > 60) {
                return this.$message.warning('时间范围不能大于60天')
            }
            this.loading = true
            getRecordList(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.pageTotal = res.data.totalCount || 0
                        res.data.list.forEach((subItem, subIndex) => {
                            subItem.reject = subItem.approvalOpinion ? '查看' : ''
                            subItem.driveEndDate = dayjs(subItem.driveEndDate).format('YYYY-MM-DD')
                            if (subItem.driverDeleteFlag === 1) {
                                subItem.driverName = getSensitiveVal(subItem.driverName, 'cname')
                                subItem._driverNameTags = '已注销'
                                subItem.phoneNo = getSensitiveVal(subItem.phoneNo, 'phone')
                                subItem._phoneNoTags = '已注销'
                            }
                            subItem.hiddenEvent = subItem.isWithCar === '1' ? '' : 'vehicle' //isWithCar: 1-是
                        })
                        this.totalData = res.data.list
                        this.selectChange()
                        this.onHandleTableDataSensitive()
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        handleApprove(){

        },
        handleReject(){

        },
        // 导出
        handleExport() {
            this.exportLoading = true
            const params = this.getParams()
            delete params.pageNo
            delete params.pageSize
            exportTransportDemand(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.data)
                    }
                })
                .finally(() => {
                    this.exportLoading = false
                })
        },
        handleBtnClick(val, index, row, prop, buttonName) {
            if (prop === 'reject' && buttonName === '查看') {
                this.$alert(row.approvalOpinion, '驳回原因', {
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: '关闭',
                }).catch(action => {});
            }
        },
        initTimeDefault() {
            let timeRange = [
                dayjs().subtract(60, 'day').format('YYYY-MM-DD 00:00:00'),
                dayjs().format('YYYY-MM-DD 23:59:59'),
            ]
            this.$refs.tablePage.$refs.searchList.searchData.timeRange = timeRange;
            this.searchTerm.timeRange = timeRange;

            if (this.$store.state.supplier) {
                //LSP
                if (this.$route.query.applyStatus !== undefined) {
                        let applyStatus = this.$route.query.applyStatus;
                        this.$refs.tablePage.$refs.searchList.searchData.applyStatus = applyStatus
                        this.searchTerm.applyStatus = applyStatus
                    }
            }

      
        },
        // 信息脱敏
        onHandleTableDataSensitive(setFlag = false){
            handleTableDataSensitive(this, 'isSensitive', 'totalData', [
                {
                    dataKey: 'phoneNo',
                    showKey: '_phoneNo',
                    type: 'phone'
                },
            ], setFlag)
        },
        handleSensitive() {
            this.onHandleTableDataSensitive(true)
        },
    },
    mounted() {
        this.initTimeDefault()
        dictWithUrl('SRM_JOIN_APPLY_STATUS').then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data
                this.loadData()
            }
        })
    },
}
</script>
<style lang="less">
.driver-add-supplier {
    .select-btn-box {
        margin-bottom: 10px;
    }

    #mPane3 .el-table {
        min-height: calc(100vh - 206px);
    }

    .cell-extra-tag span {
        color: #7f7f7f;
    }
}
</style>